import React, { Component } from 'react';
import './App.css';
import './styles/font-awesome/css/font-awesome-core.css';
// import './styles/font-awesome/css/font-awesome-solid.css';
// import './styles/font-awesome/css/font-awesome-regular.css';
import './styles/font-awesome/css/font-awesome-light.css';
import Calendar from './Calendar/Calendar'
import Slider from './Slider/Slider'

class App extends Component {
	render() {
		return (
			<div>
				<section className="hero is-info is-bold">
					<div className="hero-body">
						<div className="container">
							<h1 className="title">Available.Live</h1>
							<h2 className="subtitle">Hello, my name is Yuriy Linnyk, and I am <em>Available Live</em> as a <a href="https://www.codementor.io/yurio">Codementor</a>.
							<br/>If you'd like to schedule a meeting, this is my availability calendar.</h2>
							<a href="https://www.codementor.io/yurio" className="button">Message Me @ Codementor.io</a>
						</div>
					</div>
				</section>

				<Slider/>
				{/*
				<section className="section" style={{
					backgroundColor: 'antiquewhite'
				}}>
					<div className="container">

						<h1 className="title" style={{textAlign:'center'}}>Buy lessons now</h1>

						<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" className="columns">
							<div className="column is-half is-offset-1">
								<input type="hidden" name="cmd" value="_s-xclick" />
								<input type="hidden" name="hosted_button_id" value="63AD7N78EEUPG" />
								<input type="hidden" name="on0" value="Lessons" />

								<div className="field">
									<div className="control has-icons-left">
										<span className="select">
											<select name="os0">
												<option value="1 lesson (1 hour)">1 lesson (1 hour) $59.00 USD</option>
												<option value="2 lessons (1 hour each)">2 lessons (1 hour each) $99.00 USD</option>
												<option value="3 lessons (1 hour each)">3 lessons (1 hour each) $139.00 USD</option>
												<option value="5 lessons (1 hour each)">5 lessons (1 hour each) $219.00 USD</option>
												<option value="10 lessons (1 hour each)">10 lessons (1 hour each) $399.00 USD</option>
											</select>

											<span className="icon is-small is-left">
												<i className="fal fa-badge-check"></i>
											</span>

										</span>
									</div>
								</div>

							</div>
							<div className="column is-half">
								<input type="hidden" name="currency_code" value="USD" />
								<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" name="submit" alt="PayPal - The safer, easier way to pay online!" />

							</div>
						</form>


					</div>
				</section>
				*/}

				<section className="section calendarAppSection">
					<div className="container">
						<div id="calendarApp">
							<Calendar />
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js